
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8V6h18v2H0zm0-8h18v2H0V0zm14 14H0v-2h14v2z"}})])
          )
        }
      }
    